import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import './index.css';
import 'semantic-ui-css/semantic.min.css';
import App from './App';
import serviceWorker from './serviceWorker';
import { store } from './store';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <App />
    </Provider>,
);
serviceWorker();
